import React from "react";
import PropTypes from "prop-types";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import AuthorStreamHeader from "stream/components/AuthorStreamHeader";
import FullStoryCard from "cards/containers/FullStoryCard";
import AuthorStreamHelmet from "stream/components/AuthorStreamHelmet";

class AuthorStream extends React.Component {
  render() {
    return (
      <React.Fragment>
      
        <AuthorStreamHelmet username={this.props.match.params.username} />
        <AuthorStreamHeader username={this.props.match.params.username} />
        <StandardLayout
          main={(
            <Stream
              type={STREAM_TYPE.AUTHOR}
              lookup={this.props.match.params.username}
              onlyShowTitleForA11y={true}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              disableUrlUpdating={true}
            />
          )}
        />
      </React.Fragment>
    );
  }
}

AuthorStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string.isRequired,
    }),
  }),
};

export default AuthorStream;
